<router-outlet></router-outlet>
<div
	class="position-fixed bottom-0 end-0 m-2 px-2 py-1 bg-light border rounded text-muted small"
	style="z-index: 1100;"
	title="Application version"
>
	v{{ appVersion }}
</div>
